export const allDevicesChanelOverMaxReached = () => {
    if ($('.chanel-max, .limit-reached').length > 0) {
        $('.proceed-to-checkout-top').hide();
        $('.proceed-to-checkout-bottom').hide();
        $('#paypal-express-checkout-button-1').addClass('hidden');
        $('#paypal-express-checkout-button-2').addClass('hidden');
        $('#paypal-express-checkout-button-1').addClass('hidden');
        $('.afterpay-express-button').addClass('hidden');
        $('apple-pay-button').addClass('hidden');
    }
};
